//#region src/simple_loyalty_signup_mode.ts
var SimpleLoyaltySignupMode = /* @__PURE__ */ function(SimpleLoyaltySignupMode) {
	SimpleLoyaltySignupMode[SimpleLoyaltySignupMode["Off"] = 0] = "Off";
	SimpleLoyaltySignupMode[SimpleLoyaltySignupMode["OrderSummary"] = 1] = "OrderSummary";
	SimpleLoyaltySignupMode[SimpleLoyaltySignupMode["PaymentCompleted"] = 2] = "PaymentCompleted";
	SimpleLoyaltySignupMode[SimpleLoyaltySignupMode["PaymentCompletedForced"] = 3] = "PaymentCompletedForced";
	return SimpleLoyaltySignupMode;
}(SimpleLoyaltySignupMode || {});
//#endregion
export { SimpleLoyaltySignupMode };

//# sourceMappingURL=simple_loyalty_signup_mode.js.map